import {
  FETCH_DATA_ROOMLIST_REQUEST,
  FETCH_DATA_ROOMLIST_SUCCESS,
  FETCH_DATA_ROOMLIST_FAILURE,
  SAVE_DATA_ROOMLIST_SUCCESS
} from "./constants";

import { IBookingSite, IAction } from "./../../../models";

const initialState: IBookingSite = {
  total: 0,
  rows: [],
  error: '',
  dataBookingSite: {}
};

export function reducer(
  state = initialState,
  { type, payload }: IAction
): IBookingSite {
  switch (type) {
    case FETCH_DATA_ROOMLIST_REQUEST:
      return {
        ...state
      };
    case FETCH_DATA_ROOMLIST_SUCCESS:
      return {
        ...state,
        total: payload.total,
        rows: payload.rows
      };
    case FETCH_DATA_ROOMLIST_FAILURE:
      return {
        ...state,
        error: payload.error
      };
    case SAVE_DATA_ROOMLIST_SUCCESS:
      return {
        ...state,
        dataBookingSite: payload
      };
    default:
      return state;
  }
}
